<template>
	<div class="flex flex-col w-full justify-center items-center p-6">
		<div class="w-full max-w-8xl">
			<div class="flex flex-col md2:flex-row space-y-4 md2:space-y-0 w-full justify-between my-12 md:my-6">
				<div class="flex w-full max-w-xs">
					<div class="text-lg font-semibold text-ihh-midnight-gray mr-4 m-auto whitespace-nowrap">Sort By:</div>
					<select
						v-model="sort"
						class="cursor-pointer focus:border focus:border-ihh-dark-salmon focus:outline-0 focus:shadow shadow-ihh-dark-salmon flex w-full md2:mr-4 border rounded-lg py-3 px-2 bg-ihh-slate-gray/20 text-ihh-midnight-gray font-bold text-xs tracking-wide"
					>
						<option value="Featured Items">Featured Items</option>
						<option value="Newest Items">Newest Items</option>
						<option value="Best Selling" selected>Best Selling</option>
						<option value="A to Z">A to Z</option>
						<option value="Z to A">Z to A</option>
						<option value="By Review">By Review</option>
						<option value="Price: Ascending">Price: Ascending</option>
						<option value="Price: Descending">Price: Descending</option>
					</select>
				</div>

				<div class="flex w-full max-w-sm">
					<button
						class="group flex-row w-full m-auto items-center justify-center text-center text-sm font-semibold text-ihh-midnight-gray hover:text-ihh-white border-3 border-ihh-dark-salmon px-4 py-3 rounded-lg hover:bg-ihh-dark-salmon duration-100"
						@click="showFilters = !showFilters"
					>
						<div class="inline-flex items-center m-auto gap-x-3 mt-1.5">
							<svg class="w-5 font-bold fill-ihh-midnight-gray group-hover:fill-ihh-white rotate-90" viewBox="0 0 1024 1024">
								<path
									d="M640 288a64 64 0 1 1 0.032-128.032A64 64 0 0 1 640 288z m123.456-96c-14.304-55.04-64-96-123.456-96s-109.152 40.96-123.456 96H128v64h388.544c14.304 55.04 64 96 123.456 96s109.152-40.96 123.456-96H896V192h-132.544zM640 864a64 64 0 1 1 0.032-128.032A64 64 0 0 1 640 864m0-192c-59.456 0-109.152 40.96-123.456 96H128v64h388.544c14.304 55.04 64 96 123.456 96s109.152-40.96 123.456-96H896v-64h-132.544c-14.304-55.04-64-96-123.456-96M384 576a64 64 0 1 1 0.032-128.032A64 64 0 0 1 384 576m0-192c-59.456 0-109.152 40.96-123.456 96H128v64h132.544c14.304 55.04 64 96 123.456 96s109.152-40.96 123.456-96H896v-64H507.456c-14.304-55.04-64-96-123.456-96"
								/>
							</svg>
							<span class="">Filters</span>
							<span v-if="numberFilters" class="text-ihh-midnight-gray font-semibold">({{ number }})</span>
						</div>
					</button>
				</div>
			</div>

			<div
				class="h-screen fixed top-0 left-0 z-40 select-none w-full bg-ihh-dark-gray/60 bg-local backdrop-blur-sm"
				:class="showFilters ? '' : '-translate-x-full'"
				@click="showFilters = !showFilters"
			>
				<div class="flex w-full justify-start h-full">
					<div
						class="w-full max-w-[400px] bg-ihh-white xs:rounded-r-xl overflow-scroll transform transition-transform delay-200 duration-300 ease-in-out"
						:class="showFilters ? '' : '-translate-x-full'"
						@click.stop
					>
						<!--Your Bag Header Section -->
						<div class="flex w-full p-6 sticky top-0 bg-ihh-dark-gray z-20">
							<div class="text-ihh-white flex w-full justify-start text-start text-base">Back</div>
							<div class="flex w-full justify-end">
								<button @click="showFilters = !showFilters" class="group w-4 h-4 justify-around flex text-xl py-4 rounded-full">
									<div class="m-auto items-center flex w-full justify-center">
										<div class="rotate-45 absolute bg-ihh-white py-px rounded px-2"></div>
										<div class="-rotate-45 bg-ihh-white py-px rounded px-2"></div>
									</div>
								</button>
							</div>
						</div>

						<AddedFilters v-if="showFilters" class="py-12" v-model="filters" />
					</div>
				</div>
			</div>

			<SearchFilters class="w-full justify-end" :algoliaFilters="algoliaFilters" :mangoSearch="mangoSearch" :sort="mangoSort" />
		</div>
	</div>
</template>

<script>
import AddedFilters from './added-filters.vue'
import SearchFilters from './search-filters.vue'

export default {
	components: { AddedFilters, SearchFilters },
	props: ['brand'],
	inject: ['store'],
	data() {
		return {
			filters: {
				categories: [],
				query: '',
				price: [0, 1000],
			},
			sort: 'Best Selling',
			numberFilters: false,
			showFilters: false,
			details: [
				{ name: `Help Center`, path: `/help-center` },
				{ name: `Returns`, path: `/returns` },
				{ name: `Ordering & Shipping Info`, path: `/shipping-info` },
				{ name: `Discount Code Terms`, path: `/discount-code-terms` },
				{ name: `Gift Certificates`, path: `/gift-certificates` },
				{ name: `Sitemap`, path: `/sitemap` },
			],
		}
	},
	computed: {
		algoliaFilters() {
			if (!this.brand) return
			return `brands.id:${this.brand.id}`
		},
		mangoSearch() {
			let baseFilters = { isVisible: true }

			if (!this.brand) return baseFilters

			return {
				...baseFilters,
				brandId: this.brand.id,
				name: { $regex: this.filters.query, $options: 'i' },
				calculatedPrice: { $gt: this.filters.price[0], $lt: this.filters.price[1] },
			}
		},
		mangoSort() {
			if (this.sort == 'Best Selling') return { totalSold: -1 }
			if (this.sort == 'Newest Items') return { dateCreated: -1 }
			if (this.sort == 'A to Z') return { name: 1 }
			if (this.sort == 'Z to A') return { name: -1 }
			if (this.sort == 'By Review') return { rating: -1 }
			if (this.sort == 'Price: Ascending') return { price: 1 }
			if (this.sort == 'Price: Descending') return { price: -1 }
		},
	},
}
</script>
